import { useEffect, useRef, useState } from "react";
import { GenericComponent } from "../../components/GenericComponent";
import { Consumidores } from "../../models/Consumidores";
import { useForm } from "react-hook-form";
import { InputComponent } from "../../components/InputComponent";
import { ConsumidorService } from "../../service/ConsumidorService";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Formulario } from "./Formulario";
import { useToken } from "../../components/useToken";
import { FiltroMultiempresa } from "../../components/FiltroMultiempresa";
import { RadioButton } from "primereact/radiobutton";
import { EmpresaService } from "../../service/EmpresaService";
import { Generico } from "../../components/Generico";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { differenceInMonths } from 'date-fns';
import { FiltroUnicoAutocomplete, FiltroUnicoCatalogoFijo } from "../../components/ui/FiltrosGlobales";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { FileUpload } from "primereact/fileupload";

export const Consumidor = () => {
    const { getRol, getEmpresaOtroPermisoUsuario } = useToken();
    const generic = new GenericComponent();
    const omodel = new Consumidores(getRol()?.opcion);
    const { accionesTbl, funcSistemaError } = Generico();
    const [permss, setPermss] = useState(null);
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue } = useForm({ defaultValues });
    const toast = useRef(null);
    const [clientes, setClientes] = useState(null);
    const [catalogo, setCatalogo] = useState(null);
    const [cliente, setCliente] = useState(null);
    const [esRuc, setEsRuc] = useState(false);
    const [esCedula, setEsCedula] = useState(false);
    const [dialogFrm, setDialogFrm] = useState(false);
    const [empresa, setEmpresa] = useState(null);
    const [filtroTipo, setFiltroTipo] = useState(1);
    const [listaEmpresa, setListaEmpresa] = useState(null);
    const [dialogConsumidor, setDialogConsumidor] = useState(false);
    const [titleTipo, setTitleTipo] = useState(null);
    const consumidorService = new ConsumidorService();
    const monitoreoSrv = new MonitoreoService();
    const [selectedEmp, setSelectedEmp] = useState(null);
    const [opcion, setOpcion] = useState(null);
    const [emp, setEmp] = useState(null);
    const [dialogReporte, setDialogReporte] = useState(false);
    const [inicio, setInicio] = useState(null);
    const [fin, setFin] = useState(null);
    const [loadReport, setLoadReport] = useState(false);
    const empresaService = new EmpresaService();
    const { table, setLoading, setTotalRecords, lazyParams, inDrop, inSwitch, inText, inAutocomplete } = InputComponent({ registers: clientes, omodel, generic, errors, control, permss, id: getValues('id') });
    const [esAdmin, setEsAdmin] = useState(false);
    const [empresasReporte, setEmpresasReporte] = useState([]);
    const [empresaSelReporte, setEmpresaSelReporte] = useState(null);
    const [dialogCarga, setDialogCarga] = useState(false);
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);
    const [lista, setLista] = useState(null);
    const [archivo, setArchivo] = useState(null);
    let fileRef = useRef(null);
    const [load, setLoad] = useState(false);
    const [loadExcelPlantilla, setLoadExcelPlantilla] = useState(false);

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = (tipoConsumidor = null) => {
        setLoading(true);
        let _lazyParams = lazyParams;
        delete _lazyParams.rtipo;
        delete _lazyParams.empresa;
        if (empresa) {
            _lazyParams.empresa = empresa;
        }
        const rol = getRol();
        if (!rol) {
            toast.current.show({ severity: 'warn', summary: 'Rol no seleccionado', detail: 'Por favor selecciona un rol antes de continuar.', life: 3000 });
            setLoading(false);
            return;
        } else {
            _lazyParams.rol = rol;
        }
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        if (catalogo?.tipo_formulario && catalogo.tipo_formulario === 'Proveedor-Cliente') {
            _lazyParams.tipoConsumidor = tipoConsumidor ?? filtroTipo;
        } else if (catalogo?.tipo_formulario && catalogo.tipo_formulario !== 'Proveedor-Cliente') {
            _lazyParams.tipoConsumidor = catalogo.tipo_formulario === 'Cliente' ? 1 : 2;
        }
        consumidorService.getConsumidor({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setClientes(res.data.registros);
            setLoading(false);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
                setCatalogo(res.data.catalogo);
                setOpcion(res.data.opcion);
            }
            if (res.data.esAdmin !== undefined) {
                setEsAdmin(res.data.esAdmin);
                setEmpresasReporte(res.data.empresas_reporte || []);
            }
            if (res.data.empresas) {
                setListaEmpresa(res.data.empresas);
            }
        });
    }

    const openNew = () => {
        let inx = filtroTipo;
        if (catalogo?.tipo_formulario !== 'Proveedor-Cliente') {
            inx = catalogo.tipo_formulario === 'Cliente' ? 1 : 2;
        }
        setCliente(null);
        setTitleTipo(omodel.tipoConsumidor[inx - 1].name);
        setDialogConsumidor(true);
        reset(defaultValues);
    }

    const onSubmit = (data) => {
        if (catalogo?.tipo_formulario !== 'Proveedor-Cliente') {
            data.tipo = catalogo.tipo_formulario === 'Cliente' ? 1 : 2;
        } else {
            data.tipo = filtroTipo;
        }
        data.rol = getRol() ?? null;
        if (data.empresa == null) {
            const empresa = getEmpresaOtroPermisoUsuario();
            if (empresa) {
                data.empresa = empresa;
            }
        }
        if (getValues('id') == null) {
            consumidorService.newConsumidor(data).then(res => {
                generic.funcSuccess(res, toast);
                setDialogConsumidor(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
        else {
            consumidorService.editarConsumidor(data).then(res => {
                generic.funcSuccess(res, toast);
                setDialogConsumidor(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
    }

    const editConsumidor = () => {
        consumidorService.consultarConsumidor(cliente.id, catalogo.nem).then(res => {
            let _cons = res.data.consumidor;
            const lista = { tipo_identificacion: catalogo.tipo };
            if (listaEmpresa?.length > 0 && _cons.empresa && catalogo.nem !== 'prerol') {
                lista.empresa = listaEmpresa;
            }
            if (catalogo.nem !== 'prerol') {
                setEmp(_cons.empresa);
            }

            Object.keys(lista).forEach(function (key) {
                if (_cons[key] != null) {
                    lista[key].forEach(element => {
                        if (element.cat_id === _cons[key]) {
                            _cons[key] = element;
                        }
                    });
                }
            });
            setEsRuc(JSON.stringify(_cons.tipo_identificacion) === JSON.stringify(catalogo.ruc));
            setEsCedula(JSON.stringify(_cons.tipo_identificacion) === JSON.stringify(catalogo.cedula));
            reset(generic.renewValues(_cons, omodel.model));
            let inx = filtroTipo;
            if (catalogo?.tipo_formulario !== 'Proveedor-Cliente') {
                inx = catalogo.tipo_formulario === 'Cliente' ? 1 : 2;
            }
            setTitleTipo(omodel.tipoConsumidor[inx - 1].name)
            setDialogConsumidor(true);
        });
    }

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar la información?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminarConsumidor()
        });
    }

    const eliminarConsumidor = () => {
        consumidorService.eliminarConsumidor(cliente?.id).then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const onChangeTipo = (e) => {
        setEsRuc(JSON.stringify(e.value) === JSON.stringify(catalogo.ruc));
        setEsCedula(JSON.stringify(e.value) === JSON.stringify(catalogo.cedula));
    }

    const formularios = (daa) => {
        if (catalogo?.tipo_formulario !== 'Proveedor-Cliente') {
            setFiltroTipo(catalogo.tipo_formulario === 'Cliente' ? 1 : 2);
        }
        setDialogFrm(true);
    }

    const filtro = () => {
        return (
            <div className="flex flex-wrap gap-3">
                {omodel.tipoConsumidor.map((item) => {
                    return (
                        <div key={item.id} className="flex align-items-center">
                            <RadioButton inputId={item.id} name="filtroTipo" value={item.id} onChange={(e) => cambioTipo(e.value)} checked={filtroTipo === item.id} />
                            <label htmlFor={item.id} className="ml-2">{item.name}</label>
                        </div>
                    );
                })}
            </div>
        )
    }

    const cambioTipo = (value) => {
        setFiltroTipo(value);
        loadLazyData(value);
    }

    const searchEmp = (event) => {
        if (!event.query.trim().length) {
            setEmp(emp ? [...emp] : []);
        }
        else {
            empresaService.consultarEmpresaNombre(event.query.toLowerCase()).then(data => {
                setEmp(data);
            });
        }
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar)
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editConsumidor() } });
        if (permss?.consultar)
            items.push({ label: 'Generación de notificaciones', icon: 'pi pi-at', command: () => { formularios() } });
        if (permss?.eliminar)
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });

        return [{ label: 'Opciones', items: items }];
    }

    const tooltip_text = {
        google2fa: 'Activa o desactiva la autenticación en dos pasos',
        firmaDigital: 'Habilita o deshabilita la firma electrónica en los formularios principales',
    }

    const siOpcion = (strOpcion, crud) => {
        return crud && (opcion === 'PRELAFIT' || opcion.includes(strOpcion));
    }

    const startContent = (
        <>
            {permss?.crear && <Button icon="pi pi-plus" className="mr-2" tooltip="Nuevo" onClick={openNew} />}
            {siOpcion('consumidor-reporte', permss?.actualizar) &&
                <Button icon="pi pi-chart-bar" className="mr-2" tooltip="Reporte de Notificaciones" onClick={() => limpiarReporte(true)} />}
            {siOpcion('consumidor-carga', permss?.actualizar) &&
                <Button icon="pi pi-upload" className="mr-2" tooltip="Carga de Notificaciones" onClick={() => abrirDialogCarga()} />}
        </>
    );

    const limpiarReporte = (mostrar = null) => {
        setInicio(null);
        setFin(null);
        if (!esAdmin && empresasReporte && empresasReporte.length > 0) { // Si no es admin y hay empresas_reporte cargadas, autoseleccionamos la primera
            setEmpresaSelReporte(empresasReporte[0].value);
        } else {
            setEmpresaSelReporte(null); // Admin limpia el autocomplete
        }
        if (mostrar !== null) {
            setDialogReporte(mostrar);
        }
    }

    const generarReporte = () => {
        if (!inicio || !fin) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Seleccione el rango de fechas', life: 6000 });
            return;
        } else if (inicio > fin) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'La fecha de inicio debe ser menor a la fecha de fin', life: 6000 });
            return;
        } else if (differenceInMonths(fin, inicio) > 3) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'El rango de fechas permitido debe ser menor o igual a 3 meses', life: 6000 });
            return;
        }
        if ((esAdmin || (empresasReporte && empresasReporte.length > 1)) && !empresaSelReporte) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Seleccione una empresa para el reporte', life: 6000 });
            return;
        }
        const data = {};
        let nameReport = 'reporte-';
        if (inicio) {
            data.fecha_inicio = generic.dateToString(inicio);
            nameReport += generic.dateToString(inicio);
        }
        if (fin) {
            data.fecha_fin = generic.dateToString(fin);
            nameReport += '-' + generic.dateToString(fin);
        }
        nameReport += '.xlsx';
        setLoadReport(true);
        if (getRol()?.id) {
            data.rol = getRol()?.id;
        }
        if (empresaSelReporte) {
            data.empresa_id = typeof empresaSelReporte === 'object' ? empresaSelReporte.value : empresaSelReporte; // Previene si es objeto (autocomplete) o valor directo (dropdown)
        }
        consumidorService.buscar(data, 'form/consumidor/reporte').then(res => {
            const url = window.URL.createObjectURL(new Blob([res]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nameReport);
            document.body.appendChild(link);
            link.click();
            link.remove();
        }).catch(async (error) => {
            const responseObj = await error.response.data.text();
            error.response.data = JSON.parse(responseObj);
            generic.funcError(error, toast, setError);
        }).finally(() => {
            setLoadReport(false);
        });
    }

    const buscarSugerenciasEmpresa = (texto) => {
        return monitoreoSrv.consultarInfo('administracion/catalogo/empresas', { texto }).then((res) => {
            return res.data
        }).catch((error) => {
            funcSistemaError(error, toast);
            return [];
        }).finally(() => {

        });
    };

    const searchEmpresa = (event) => {
        if (!event.query.trim().length) {
            setLista(lista ? [...lista] : []);
        }
        else {
            monitoreoSrv.consultar(event.query.toLowerCase(), 'administracion/empresa-buscar/razon').then(data => {
                setLista(data);
            });
        }
    }

    const fileUploadHandler = ({ files }) => {
        const [file] = files;
        const size = parseInt(process.env.REACT_APP_PEP_SIZE);
        if (file.size > size) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Tamaño máximo del archivo es: ' + (size / 1000) + " Kb", life: 3000 });
        }
        else {
            setArchivo(file);
        }
        fileRef?.clear();
    }

    const selectFile = (e) => {
        const size = parseInt(process.env.REACT_APP_PEP_SIZE);
        if (e.files.length <= 0 || e.files[0].size > size) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Tamaño máximo del archivo es: ' + (size / 1000) + " Kb", life: 3000 });
        }
        else {
            setArchivo(e.files[0]);
        }
        fileRef?.clear();
    }

    const limpiarArchivo = () => {
        setArchivo(null);
        if (fileRef && fileRef.clear) {
            fileRef.clear();
        }
    };

    const abrirDialogCarga = () => {
        setArchivo(null);
        setSelectedEmpresa(null);
        setValue('empresa', null); // Evita arrastrar la empresa seleccionada en el diálogo de Nuevo/Editar consumidor
        setDialogCarga(true);
    }

    const cerrarDialogCarga = () => {
        setDialogCarga(false);
        setSelectedEmpresa(null);
        limpiarArchivo();
    }

    const subida = () => {
        if (archivo === null) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar el archivo.', life: 3000 });
            return;
        }

        const formData = new FormData();
        formData.append('file', archivo, archivo.name);
        formData.append('empresa', getValues('empresa')?.cat_id ?? null);
        setLoad(true);
        monitoreoSrv.subirArchivoHibrido('form/consumidor/cargar', formData).then(res => {
            const _consulta = res.headers['x-consulta'];
            if (!_consulta) {
                res.data.text().then(text => {
                    const _inf = JSON.parse(text);
                    generic.funcSuccess(_inf, toast);
                });
            } else {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', "reporte_errores.xlsx"); // o usa nameReport
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
            cerrarDialogCarga();
            loadLazyData();
        }).catch(error => {
            generic.funcDeleteError(error, toast, setError);
        }).finally(() => {
            setLoad(false);
        });
    }

    const ejecutarDescargaPlantilla = () => {
        setLoadExcelPlantilla(true);

        monitoreoSrv.generarDocumento('form/consumidor/descargar-plantilla').then((res) => {
            generic.downloadPdf(res.data, 'plantilla_notificacion_masiva.xlsx');
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: `Plantilla descargada`, life: 6000 });
        }).catch((error) => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            setLoadExcelPlantilla(false);
        });
    };

    return (
        <>
            <ConfirmDialog />
            <Toast ref={toast} />
            {getRol() && getRol()?.ideg && <FiltroMultiempresa loadLazyData={loadLazyData} setEmpresa={setEmpresa} />}
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={startContent}></Toolbar>
                {catalogo?.tipo_formulario === 'Proveedor-Cliente' && filtro()}
                <br />
                {table({ action01: accionesTbl, reg: setCliente, items: itemsMenu() })}
            </Card>

            <Dialog visible={dialogConsumidor} header={(getValues('id') == null ? "Nuevo " : "Editar ") + titleTipo} modal className="p-fluid modal-ssize"
                onHide={e => setDialogConsumidor(false)} style={{ maxWidth: '800px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inDrop('tipo_identificacion', catalogo?.tipo, { lab: omodel.optionLabel, chn: onChangeTipo }, 6)}
                        {esCedula && inText('identificacion', generic.infoIdentificacion('cedula'), 6)}
                        {!esCedula && !esRuc && inText('identificacion', {}, 6)}
                        {esRuc && inText('identificacion', generic.infoIdentificacion('ruc'), 6)}
                        {inText('nombre', {}, 6)}
                        {inText('email', { pattern: omodel.pattern }, 6)}
                        {inSwitch('estado', { labelTrue: 'SI', labelFalse: 'NO', tooltip: tooltip_text.habilitar }, 6)}
                        {inSwitch('google_2fa_enabled', { labelTrue: 'SI', labelFalse: 'NO', tooltip: tooltip_text.google2fa, ne: 'disabled' }, 6)}
                        {inSwitch('firma_digital_activa', { labelTrue: 'SI', labelFalse: 'NO', tooltip: tooltip_text.firmaDigital, ne: 'disabled' }, 6)}
                        {inText('email2', { obl: 'no' }, 6)}
                        {listaEmpresa?.length > 0 && inDrop('empresa', listaEmpresa, { lab: omodel.optionLabel }, 6)}
                        {(!listaEmpresa?.length || listaEmpresa?.length <= 0) && catalogo?.nem === 'prerol' &&
                            inAutocomplete('empresa', selectedEmp, setSelectedEmp, emp, searchEmp, { lab: omodel.optionLabel, noEsActividad: true, col: 12 })}
                    </div>

                    {generic.buttonsForms(setDialogConsumidor)}
                </form>
            </Dialog>

            <Dialog visible={dialogReporte} header="Generar Reporte" modal className="p-fluid modal-ssize"
                onHide={e => setDialogReporte(false)} style={{ width: '90vw', maxWidth: '500px' }}>
                <div className="formgrid grid mt-3">
                    {(esAdmin || (empresasReporte && empresasReporte.length > 1)) && (
                        <div className="field col-12">
                            <label className="font-bold block mb-2">Empresa*</label>
                            {esAdmin ? (
                                <FiltroUnicoAutocomplete id="ac-empresa-reporte" value={empresaSelReporte} onChange={setEmpresaSelReporte} fetchData={buscarSugerenciasEmpresa} placeholder="Buscar empresa..." icon="pi pi-building" />
                            ) : (
                                <FiltroUnicoCatalogoFijo value={empresaSelReporte} options={empresasReporte} onChange={setEmpresaSelReporte} placeholder="Seleccione Empresa" icon="pi pi-building" />
                            )}
                        </div>
                    )}
                    <div className="field col-6">
                        <label htmlFor="fechaInicio" className="font-bold block mb-2">
                            Fecha Inicio*
                        </label>
                        <Calendar id="fechaInicio" value={inicio} onChange={(e) => setInicio(e.value)} showIcon readOnlyInput />
                    </div>

                    <div className="field col-6">
                        <label htmlFor="fechaFin" className="font-bold block mb-2">
                            Fecha Fin*
                        </label>
                        <Calendar id="fechaFin" value={fin} onChange={(e) => setFin(e.value)} showIcon readOnlyInput />
                    </div>

                    <div className="col-12 mt-1">
                        <span style={{ color: 'red', fontSize: '11px', fontWeight: 'bold' }}>
                            *Fecha de envío de solicitud de formulario, 3 meses de rango permitido
                        </span>
                    </div>

                    <div className="field col-12 flex justify-content-center gap-3 mt-4">
                        <Button label="Generar" style={{ maxWidth: '130px' }} type="button" onClick={() => generarReporte()} icon="pi pi-file-excel" className="p-button-warning" loading={loadReport} />
                        <Button label="Limpiar" style={{ maxWidth: '130px' }} icon="pi pi-stop" type="button" disabled={loadReport} className="p-button-secondary p-button-outlined" onClick={() => limpiarReporte()} />
                    </div>
                </div>
            </Dialog>

            <Dialog visible={dialogFrm} header={"Envío de formularios a: " + cliente?.nombre} modal className="p-fluid modal-ssize" onHide={e => setDialogFrm(false)}
                style={{ maxWidth: '1000px' }}>
                <Formulario toast={toast} generic={generic} id={cliente?.id} clienteEmpresaId={cliente?.empresa_id} permss={permss} empresa={empresa} tipo={filtroTipo} opcion={opcion} />
            </Dialog>

            <Dialog visible={dialogCarga} header="Carga de Notificaciones" modal className="p-fluid dialog-personalizado"
                onHide={cerrarDialogCarga} style={{ maxWidth: '460px' }}>
                <div className="p-4">
                    <div className="flex align-items-center justify-content-between p-3 mb-4 border-round-lg border-1 surface-border surface-50">
                        <div className="flex align-items-center gap-2">
                            <i className="pi pi-question-circle text-primary text-lg"></i>
                            <div className="flex flex-column">
                                <span className="font-semibold text-800 text-sm">¿No tienes la plantilla?</span>
                                <span className="text-xs text-color-secondary">Descárgela aquí en formato .xlsx</span>
                            </div>
                        </div>
                        <Button label="Descargar" icon="pi pi-download" className="p-button-outlined p-button-sm w-auto"
                            type="button" onClick={ejecutarDescargaPlantilla} loading={loadExcelPlantilla} disabled={load} />
                    </div>

                    <div className="flex align-items-start gap-3 mb-4">
                        <div className="flex-shrink-0 flex align-items-center justify-content-center border-round-lg" style={{ width: '52px', height: '52px', background: 'var(--green-50)' }}>
                            <i className="pi pi-file-excel text-3xl" style={{ color: 'var(--green-700)' }}></i>
                        </div>
                        <div>
                            <h4 className="m-0 mb-1 text-900">Subir Plantilla Llena</h4>
                            <p className="m-0 text-color-secondary line-height-3 text-sm">
                                Seleccione la empresa y el archivo Excel (.xlsx) previamente llenado.
                            </p>
                        </div>
                    </div>

                    {permss?.actualizar && (opcion === 'PRELAFIT' || opcion?.includes('RIESGO_CLIENTE-LISTA-EMPRESA')) && (
                        <div className="field mb-4">
                            {opcion === 'PRELAFIT' ? (
                                inAutocomplete('empresa', selectedEmpresa, setSelectedEmpresa, lista, searchEmpresa, { lab: omodel.optionLabel, col: 12, noEsActividad: true })
                            ) : (
                                inDrop('empresa', catalogo?.empresas, { lab: 'nombre', etiqueta: 'Empresa', showClear: true }, 12)
                            )}
                        </div>
                    )}

                    {/* Zona de Archivo */}
                    <div className="field mb-4">
                        <label className="font-bold block mb-2 text-sm">Archivo Excel *</label>
                        {!archivo ? (
                            <FileUpload name="file" accept=".xlsx" maxFileSize={parseInt(process.env.REACT_APP_PEP_SIZE)}
                                uploadHandler={fileUploadHandler} mode="basic" customUpload chooseLabel="Seleccionar Archivo Excel"
                                onSelect={selectFile} ref={ref => { fileRef = ref }}
                                chooseOptions={{ icon: 'pi pi-fw pi-upload', className: 'p-button-outlined p-button-secondary w-full border-dashed' }}
                                className="w-full" tooltip={omodel.insCarga} />
                        ) : (
                            <div className="flex align-items-center justify-content-between p-3 border-1 border-green-300 border-round bg-green-50">
                                <div className="flex align-items-center gap-3">
                                    <i className="pi pi-file-excel text-green-600 text-2xl"></i>
                                    <div className="flex flex-column">
                                        <span className="text-green-800 font-medium text-sm">
                                            {archivo.name}
                                        </span>
                                        <span className="text-xs text-green-600">
                                            {(archivo.size / 1024 / 1024).toFixed(2)} MB
                                        </span>
                                    </div>
                                </div>
                                <Button icon="pi pi-times" className="p-button-rounded p-button-danger p-button-text p-button-sm m-0 p-2" onClick={limpiarArchivo} tooltip="Quitar archivo" tooltipOptions={{ position: 'top' }} disabled={load} type="button" />
                            </div>
                        )}
                    </div>

                    <div className="flex gap-2 w-full mt-2">
                        <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-secondary w-full" onClick={cerrarDialogCarga} disabled={load} />
                        <Button label="Procesar Excel" icon="pi pi-cloud-upload" className="p-button-success w-full" onClick={subida} loading={load} disabled={!archivo} />
                    </div>
                </div>
            </Dialog>
        </>
    )
}
